// removed by extract-text-webpack-plugin
module.exports = {"customPackageWrapper":"_1ZG__OYkOKInFo2hc3-PgD","contactUs":"_9MfwBY33y4uNi6CYsLw2V","boldText":"_30fWBrbKMpZtGPGRi6HMo7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomPackage/CustomPackage.scss
// module id = 1585
// module chunks = 0